import React, { useState, useCallback } from "react";

import usersExploreApi from "apis/usersExplore";
import { PageLoader, Typography } from "clearsense-ui/components";
import ExploreContainer from "components/Common/ExploreContainer";
import FilterHeader from "components/Common/FilterHeader";
import { useUserState } from "contexts/user";
import { useColumnHeaderSelector } from "hooks/useColumnHeaderSelector";
import useSearchAndPaginate from "hooks/useSearchAndPaginate";
import { getPermissions } from "utils/roleBasedAccess";

import DeleteBusinessTerms from "./DeleteBusinessTerms";
import BusinessTermsTable from "./Table";

import { DATA_SOURCE_BUSINESS_TERM_COLUMN } from "../../constants/businessTermsExplore";
import PeopleSummaryCard from "../PeopleSummaryCard";

const BusinessTerms = ({ features, steward, fetchSteward }) => {
  const [checkedRows, setCheckedRows] = useState([]);
  const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [businessTerms, setBusinessTerms] = useState([]);

  const user = useUserState();
  const userPermissions = getPermissions(features, user?.role);

  const fetchBusinessTerms = useCallback(async () => {
    try {
      setIsLoading(true);
      const params = new URLSearchParams(window.location.search);
      const search = params.get("search") || "";
      const currentPage = params.get("page") || 1;
      const pageSize = params.get("per_page") || 10;
      const { data } = await usersExploreApi.fetchBusinessTerms(
        steward?.id,
        currentPage,
        pageSize,
        search
      );
      setBusinessTerms(data?.business_terms);
    } catch (error) {
      logger.error(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const filterParams = useSearchAndPaginate(fetchBusinessTerms, {
    all: () => setCheckedRows([]),
  });

  const columnHeaderSelector = useColumnHeaderSelector(
    DATA_SOURCE_BUSINESS_TERM_COLUMN
  );

  return (
    <>
      <ExploreContainer>
        <div className="flex justify-between">
          <Typography style="h3" type="semibold">
            Business Terms for {steward.name} (
            {businessTerms?.business_term_count})
          </Typography>
          <div className="m-auto">
            <Typography style="h3" type="semibold">
              Summary
            </Typography>
          </div>
        </div>
        <PeopleSummaryCard steward={steward} />
        <FilterHeader
          entity="Business Term"
          columnHeaderSelector={columnHeaderSelector}
          filterParams={filterParams}
          count={businessTerms?.business_term_count}
          checkedRows={checkedRows}
          setIsDeleteAlertOpen={setIsDeleteAlertOpen}
          userPermissions={userPermissions}
        />
        {isLoading ? (
          <PageLoader />
        ) : (
          <BusinessTermsTable
            businessTerms={businessTerms?.business_terms}
            businessTermLength={businessTerms?.business_term_count}
            columns={columnHeaderSelector.columns}
            setCheckedRows={setCheckedRows}
            checkedRows={checkedRows}
            userPermissions={userPermissions}
            filterParams={filterParams}
            data-cy="business-terms-table"
          />
        )}
      </ExploreContainer>
      <DeleteBusinessTerms
        checkedRows={checkedRows}
        isDeleteAlertOpen={isDeleteAlertOpen}
        setIsDeleteAlertOpen={setIsDeleteAlertOpen}
        setCheckedRows={setCheckedRows}
        setIsLoading={setIsLoading}
        fetchSteward={fetchSteward}
        fetchBusinessTerms={fetchBusinessTerms}
      />
    </>
  );
};
export default BusinessTerms;
